import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import './Vision.css';

export default class Vision extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  render() {
    return (
      <div className="Vision">
        <Grid>
          <Row>
            <Col md={12}>
              <h3 className="title">Nuestra Visión</h3>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <p>
                Enfrentamos con entusiasmo cada nueva etapa de crecimiento
                y diversificación. Asumimos el desafío de mantener el liderazgo
                alcanzado y seguir construyendo sobre la base de la responsabilidad,
                la innovación, la confianza y credibilidad.
              </p>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Vision.js